export default class Alert {
  static show(text, type = 'success') {
    alert(text);
  }
};
